import axios from 'axios'
import AppHeader from '../AppHeader'

var utils = require('../../utils')
export default {
  name: 'user-pdf',
  created () {
    // ブラウザの判定
    var userAgent = window.navigator.userAgent.toLowerCase()
    if(userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
    this.msFlag = true
    }
    this.search()
  },
  data () {
    return {
      pdfFile: { file: null, name: null, upload_path: null },
      pdfPath: null,
      searchCallbackFlag: false,
      license_date: null,
      insurance_date: null,
      car_date: null,
      background_date: null,
      referencePath: null,
      msFlag: false,
      inputClear: true,
      over_day: ""
    }
  },
  computed: {
    pdfFileName () {
      return this.pdfFile.name
    },
    pdfFilePath () {
      return this.pdfPath
    },
    pdfFileName () {
      return this.pdfFile.name
    },
    pdfData () {
      return this.$store.getters.pdfData
    },
    updateReferencePath () {
      return this.$store.getters.updateReferencePath
    },
    updateFilePath () {
      return this.$store.getters.updateFilePath
    },
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    license_end_date: function() {
      return this.license_date ? this.license_date.getFullYear() + '-' + ("0" + (this.license_date.getMonth() + 1)).slice(-2) + '-' + ("0" + this.license_date.getDate()).slice(-2) : ''
    },
    insurance_end_date: function() {
      return this.insurance_date ? this.insurance_date.getFullYear() + '-' + ("0" + (this.insurance_date.getMonth() + 1)).slice(-2) + '-' + ("0" + this.insurance_date.getDate()).slice(-2) : ''
    },
    car_end_date: function() {
      return this.car_date ? this.car_date.getFullYear() + '-' + ("0" + (this.car_date.getMonth() + 1)).slice(-2) + '-' + ("0" + this.car_date.getDate()).slice(-2) : ''
    },
    background_end_date: function() {
      return this.background_date ? this.background_date.getFullYear() + '-' + ("0" + (this.background_date.getMonth() + 1)).slice(-2) + '-' + ("0" + this.background_date.getDate()).slice(-2) : ''
    },
    afterOver () {
      var today = new Date()
      var todaydate = today.getFullYear() * 10000 + (today.getMonth() + 1) * 100 + today.getDate()
      var overdate = this.over_day ? this.over_day.replace(/-/g,"") : 99999999
      if (overdate <= todaydate){
        return true
      } else {
        return false
      }
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function() {
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
        self.license_date = self.pdfData.data.attributes['user-license-file-date']
        self.insurance_date = self.pdfData.data.attributes['user-insurance-file-date']
        self.car_date = self.pdfData.data.attributes['user-car-file-date']
        self.background_date = self.pdfData.data.attributes['user-background-file-date']
        self.$refs.appHeader.getNotice()
        self.over_day = self.pdfData.data.attributes['user-overday']
      }
      var data = {
        user_id: this.$route.params.id
      }
      this.$store.dispatch('SEARCH_PDF_FILE', {
        data: data,
        callback: callback
      })
    },
    goUserLists: function () {
      this.$router.push({ path: '/users' })
    },
    goUserDetail: function () {
      window.sessionStorage.setItem('BackPage', '/users/')
      this.$router.push({ path: '/users/' + this.$route.params.id })
    },
    goBackList: function () {
      this.$router.push({ path: sessionStorage.getItem("BackPage") })
    },
    /** 署名のPDFファイルを選択 */
    selectedPdf: function(file_type,event) {
      if (event) {
        var files = event.target.files
        var file = files[0]
        this.pdfPath = window.URL.createObjectURL(file)
        if (file == undefined) {
          this.pdfFile = {
            file: null,
            name: null,
            type: null ,
            upload_path: null
          }
        } else {
          this.pdfFile = {
            file: file,
            name: file.name,
            type: file_type,
            upload_path: null
          }

          this.pdfFile.upload_path = null
          this.inputClear = false
          this.$nextTick(function () {
            this.inputClear = true
          })

          var form = new FormData()
          form.append('file', this.pdfFile.file)

          var self = this
          var callback = function() {
            self.referencePath = self.updateReferencePath
            self.pdfFile.upload_path = self.updateFilePath
            if (self.msFlag) {
              self.savePdf()
            } else {
              var $btnOpen = document.getElementById('pdf_modal_open')
              $btnOpen.click()
            }
          }
          this.$store.dispatch('UPLOAD_PDF_FILE', {
            data: form,
            callback: callback
          })
        }
      }
    },
    savePdf: function() {
      var data = {
        user_id: this.$route.params.id,
        file_name: this.pdfFile.name,
        file_type: this.pdfFile.type,
        file_path: this.pdfFile.upload_path
      }
      // 期限日をリセット
      switch(this.pdfFile.type) {
        case "license":
          this.license_date = ""
        break
        case "insurance":
          this.insurance_date = ""
        break
        case "car":
          this.car_date = ""
        break
        case "background":
          this.background_date = ""
        break
      }
      this.$store.dispatch('SAVE_PDF_FILE', {
        data: data,
        callback: this.search
      })
    },
    pdfDelete: function(file_type) {
      if (window.confirm(this.$t('Delete Confirm'))) {
        var data = {
          user_id: this.$route.params.id,
          type: file_type
        }
        this.$store.dispatch('DELETE_PDF_FILE', {
          data: data,
          callback: this.search
        })
      }
    },
    deletePath: function() {
      var data = {
        path: this.pdfFile.upload_path
      }
      this.$store.dispatch('DELETE_PATH', {
        data: data
      })
    },
    deadlineDate: function(file_type) {
      var self = this
      var data = {
        user_id: this.$route.params.id,
        type: file_type,
        shop_id: this.pdfData.data.attributes['shop-id']
      }
      var hiduke = /^(\d{4})-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/
      if (file_type == 'license') {
        if (hiduke.test(this.license_end_date) || this.license_end_date == '') {
          var callback = function () {
            self.search()
            window.alert('運転免許証を更新しました。')
          }
          data['dead_line_date'] = this.license_end_date
          this.$store.dispatch('UPDATE_NOTICE_DATE', {
            data: data,
            callback: callback
          })
        }
      } else if (file_type == 'insurance') {
        if (hiduke.test(this.insurance_end_date) || this.insurance_end_date == '') {
          var callback = function () {
            self.search()
            window.alert('任意保険証を更新しました。')
          }
          data['dead_line_date'] = this.insurance_end_date
          this.$store.dispatch('UPDATE_NOTICE_DATE', {
            data: data,
            callback: callback
          })
        }
      } else if (file_type == 'car') {
        if (hiduke.test(this.car_end_date) || this.car_end_date == '') {
          var callback = function () {
            self.search()
            window.alert('車検証を更新しました。')
          }
          data['dead_line_date'] = this.car_end_date
          this.$store.dispatch('UPDATE_NOTICE_DATE', {
            data: data,
            callback: callback
          })
        }
      } else if (file_type == 'background') {
        if (hiduke.test(this.background_end_date) || this.background_end_date == '') {
          var callback = function () {
            self.search()
            window.alert('身元保証書・保証人住民票・印鑑登録証明書・保証人確認票を更新しました。')
          }
          data['dead_line_date'] = this.background_end_date
          this.$store.dispatch('UPDATE_NOTICE_DATE', {
            data: data,
            callback: callback
          })
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/user-pdf.js